// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2xgrv","errors":"Errors_errors__32OQR"};